import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { DEFAULT_CARLEAD_CONFIGS } from '@wkda/marketing-components';

const extendedCarleadCreationConfig = {
  ...DEFAULT_CARLEAD_CONFIGS['fr-FR'],
  marketingAttributes: {
    ...DEFAULT_CARLEAD_CONFIGS['fr-FR'].marketingAttributes,
    'lead-conversational-lead-toggle': 0,
  },
};

export default generateCarleadCreationConfig(extendedCarleadCreationConfig);

